import { ZfBox, ZfCard, ZfCardMedia, ZfCardMediaHeader, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getImageUrlByString } from '../../../../styles/assets/imageMap';
import { useTopics } from '../../../api';
import type { TopLevelTopicDto } from '../../../api/generated/client';
import type { IThinTopic } from '../../../interfaces/topic';
import { getMaxDialogTileHeight, getMaxDialogTileWidth } from '../../../utils/topicUtils';

interface IProps {
    onTopicClick: (topic?: TopLevelTopicDto) => void;
    width: number;
    aspectRatio: number;
}

export const TopicDialogTiles: FunctionComponent<IProps> = ({ onTopicClick, width, aspectRatio }) => {
    const { t, i18n } = useTranslation();
    const { data: topics } = useTopics();

    const [selectedTopic, setSelectedTopic] = useState<IThinTopic | undefined>(undefined);

    const onTopicSelect = (topic: TopLevelTopicDto, selected: boolean) => {
        const topic_ = selected ? topic : undefined;
        setSelectedTopic(topic_);
        onTopicClick(topic_);
    };

    if (!topics) return null;

    return (
        <>
            <ZfBox
                style={{
                    height: '100%',
                    minWidth: 0,
                    gridColumn: 1,
                    gridRow: 1,
                    borderRadius: '3px',
                    display: 'flex',
                    overflow: 'hidden',
                }}
            >
                <span className="select-topic-modal__info-tile">{t('selectCategoryToBegin')}</span>
            </ZfBox>
            {topics.map((topic, index) => (
                <ZfBox className="user-dashboard__topic-tile" style={{ gridRow: index > 2 ? 2 : 1 }} key={index}>
                    <ZfCard
                        key={topic.id}
                        onCardSelect={(event: CustomEvent<boolean>) => onTopicSelect(topic, event.detail)}
                        selectable={true}
                        selected={selectedTopic?.id === topic.id}
                    >
                        <ZfCardMedia
                            image={getImageUrlByString(topic.key)}
                            style={{ width: `${getMaxDialogTileWidth(width)}px`, height: `${getMaxDialogTileHeight(width, aspectRatio)}px` }}
                        >
                            <ZfCardMediaHeader>
                                <ZfTypography slot="leading" variant="body-large" color="invert">
                                    {topic.name[i18n.language]}
                                </ZfTypography>
                            </ZfCardMediaHeader>
                        </ZfCardMedia>
                    </ZfCard>
                </ZfBox>
            ))}
        </>
    );
};
